import request from '@/utils/request';

export function getRole(data) {
  return request({
    url: '/adminapi/role',
    method: 'get',
    params: data
  });
}

export function getRoleDetail(params) {
  return request({
    url: '/adminapi/role',
    method: 'get',
    params
  });
}
export function addOrEditRole({ data, method }) {
  return request({
    url: '/adminapi/role',
    method,
    data
  });
}

export function putRole(data) {
  return request({
    url: '/adminapi/role',
    method: 'put',
    data
  });
}

export function delRole(data) {
  return request({
    url: '/adminapi/role',
    method: 'delete',
    data
  });
}

export function fetchRoles(data) {
  return request({
    url: '/adminapi/roles',
    method: 'get',
    params: data
  });
}

export function fetchAllRoles(data) {
  return request({
    url: '/adminapi/roles/all',
    method: 'get',
    params: data
  });
}

// 查询角色下用户
export function fetchRoleUsers(data) {
  return request({
    url: '/adminapi/role/users',
    method: 'get',
    params: data
  });
}

export function fetchRolesStructure(data) {
  return request({
    url: '/adminapi/role-structure',
    method: 'get',
    params: data
  });
}

//上传导入人员及推广人员
export function uploadAttendee(data) {
  return request({
    url: '/adminapi/questionnaire/attendee/import/structure',
    method: 'post',
    data
  });
}

// 批量导入 带数量 问卷需求
export function uploadAttendeeImport(data) {
  return request({
    url: '/adminapi/questionnaire/attendee/import',
    method: 'post',
    data
  });
}
